<div class="img-box">
    <ng-content></ng-content>
</div>  